import { Injectable, Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "safeUrl" })
@Injectable({
	providedIn: 'root'
})
export class SafeUrlPipe implements PipeTransform {
	private sanitizer = inject(DomSanitizer);

	transform(url) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
}
